export const isValidEmail = email => /.+@.+\..+/.test(email)
